"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

var _SurveyRadio2 = _interopRequireDefault(require("./SurveyRadio"));

var _Survey = _interopRequireDefault(require("../survey/Survey"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SurveyCheck =
/*#__PURE__*/
function (_SurveyRadio) {
  _inherits(SurveyCheck, _SurveyRadio);

  function SurveyCheck(component, options, data) {
    var _this;

    _classCallCheck(this, SurveyCheck);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SurveyCheck).call(this, component, options, data));
    _this.maxScore = _this.component.values.reduce(function (max, val) {
      return max + val.score;
    }, 0) * _this.component.questions.length;
    return _this;
  }

  _createClass(SurveyCheck, [{
    key: "getValue",
    value: function getValue() {
      var _this2 = this;

      if (this.viewOnly) {
        return this.dataValue;
      }

      var value = {};

      _lodash.default.each(this.component.questions, function (question) {
        value[question.value] = _this2.inputs.reduce(function (values, input) {
          if (input.checked && input.name === _this2.getInputName(question)) {
            values.push(input.value);
          }

          return values;
        }, []);
      });

      return value;
    }
  }, {
    key: "getView",
    value: function getView(valueObj) {
      var _this3 = this;

      if (!valueObj) {
        return '';
      }

      var table = this.ce('table', {
        class: 'table table-striped table-bordered table-condensed'
      });
      var tbody = this.ce('tbody');

      _lodash.default.each(valueObj, function (valuesArr, question) {
        if (valuesArr.length > 0) {
          var row = _this3.ce('tr');

          var questionCell = _this3.ce('th');

          var valueCell = _this3.ce('td');

          var questionText = _lodash.default.find(_this3.component.questions, ['value', question]).label;

          var valueTextArr = valuesArr.reduce(function (res, value) {
            var valueLabel = _lodash.default.find(_this3.component.values, ['value', value]).label;

            if (valueLabel) res.push(valueLabel);
            return res;
          }, []);
          questionCell.appendChild(_this3.text(questionText));
          valueCell.appendChild(_this3.text(valueTextArr.join(', ')));
          row.appendChild(questionCell);
          row.appendChild(valueCell);
          tbody.appendChild(row);
        }
      });

      table.appendChild(tbody);
      return table.outerHTML;
    }
  }, {
    key: "getScore",
    value: function getScore() {
      var _this4 = this;

      var valueObj = this.dataValue;
      var score = 0;

      for (var key in valueObj) {
        if (valueObj.hasOwnProperty(key) && valueObj[key]) {
          score = score + valueObj[key].reduce(function (sum, val) {
            return sum + (_this4.valueScoreMap[val] || 0);
          }, 0);
        }
      }

      return score ? score : 0;
    }
  }, {
    key: "build",
    value: function build() {
      var _this5 = this;

      if (this.viewOnly) {
        this.viewOnlyBuild();
      } else {
        this.createElement();
        var labelAtTheBottom = this.component.labelPosition === 'bottom';

        if (!labelAtTheBottom) {
          this.createLabel(this.element);
        }

        this.table = this.ce('table', {
          class: 'table table-striped table-bordered'
        });
        this.setInputStyles(this.table); // Build header.

        var thead = this.ce('thead');
        var thr = this.ce('tr');
        thr.appendChild(this.ce('td'));

        _lodash.default.each(this.component.values, function (value) {
          var th = _this5.ce('th', {
            style: 'text-align: center;'
          });

          th.appendChild(_this5.text(value.label));
          thr.appendChild(th);
        });

        thead.appendChild(thr);
        this.table.appendChild(thead); // Build the body.

        var tbody = this.ce('tbody');

        _lodash.default.each(this.component.questions, function (question) {
          var tr = _this5.ce('tr');

          var td = _this5.ce('td');

          td.appendChild(_this5.text(question.label));
          tr.appendChild(td);

          _lodash.default.each(_this5.component.values, function (value) {
            var td = _this5.ce('td', {
              style: 'text-align: center;'
            });

            var input = _this5.ce('input', {
              type: 'checkbox',
              name: _this5.getInputName(question),
              value: value.value,
              id: "".concat(_this5.id, "-").concat(question.value, "-").concat(value.value)
            });

            _this5.addInput(input, td);

            tr.appendChild(td);
          });

          tbody.appendChild(tr);
        });

        this.table.appendChild(tbody);
        this.element.appendChild(this.table);
        this.errorContainer = this.element;

        if (labelAtTheBottom) {
          this.createLabel(this.element);
        }

        this.createDescription(this.element);
        this.restoreValue();

        if (this.shouldDisable) {
          this.disabled = true;
        }

        this.autofocus();
      }

      this.attachLogic();
    }
  }, {
    key: "defaultSchema",
    get: function get() {
      return SurveyCheck.schema();
    }
  }], [{
    key: "schema",
    value: function schema() {
      for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
        extend[_key] = arguments[_key];
      }

      return _Survey.default.schema.apply(_Survey.default, [{
        type: 'expertiseSurveyCheck',
        label: 'Survey checkbox',
        key: 'expertiseSurveyCheck'
      }].concat(extend));
    }
  }, {
    key: "builderInfo",
    get: function get() {
      return {
        title: 'Survey checkbox',
        icon: 'fa fa-list',
        group: 'expertise',
        weight: 50,
        schema: SurveyCheck.schema()
      };
    }
  }]);

  return SurveyCheck;
}(_SurveyRadio2.default);

exports.default = SurveyCheck;